<template>
  <div id="app" class="app">
    <router-view/>
    <vuestic-modal ref="logoff" :cancelClass="'none'" :okClass="'none'">
      <div class="col-md-12 d-flex justify-content-center" style="background: #1c2d5a;">
        <img  src="/logo.png" alt="NovoCFC" style="width: 200px;">
      </div><br>
      <div style="text-align: center;">
        <h3>Sua sessão expirou ou seu usuário logou em outro dispositivo.</h3>
        <p>Favor tente novamente.</p>
      </div>

        <div class="modal-footer">
          <slot name="footer">
            <button type="button" class="btn btn-primary btn-block" @click='redirect()'>
              OK
            </button>
          </slot>
        </div>
    </vuestic-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import router from './router'
import urlApi from './router/urlApiV2'
import store from './store'

import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'app',
    data() {
      return {
        rotasLogin: ['login', 'loginAluno', 'loginInstrutor', 'redefinir-senha', 'nova-senha', 'nova-senha-expirado', 'login-sessao-ativa'],
        rotasEad:   ['mobileStream'],
        openRoutes: ['privacidade']
      }
    },
    mounted() {
      if(!this.rotasLogin.includes(this.$route.name) && !this.rotasEad.includes(this.$route.name) && !window.location.href.includes('/ead/'))
      {
        this.dados()
      }

    },
    methods: {
      dados(){
        this.$http.get(urlApi+'/user/dados').then((response) => {
          window.localStorage['schema']   = response.body.dados.schema
          window.localStorage['email']    = response.body.dados.email
          window.localStorage['id_role']  = response.body.dados.id_funcao_usuario
          window.localStorage['usuario']  = JSON.stringify(response.body.dados)
          if(window.localStorage['schema'] != response.body.dados.tenant_schema)
          {
            window.localStorage['schema']  = response.body.dados.tenant_schema
          }
          store.commit('authenticated')
        })
      },
      redirect(){
        if(localStorage.getItem('schema') == null)
        {
          if(this.rotasLogin.includes(this.$route.name) || this.rotasEad.includes(this.$route.name))
          {
            this.$refs.logoff.close()
          }else
          {
            router.push({ name: 'login', params: { autoescola: '' } })
          }
          return
        }
        if(!this.login && !this.rotasLogin.includes(this.$route.name))
        {
          switch (localStorage.getItem('id_role')) {
            case '1':
              router.push({ name: 'login', params: { autoescola: localStorage.getItem('schema') } })
              break;
            case '2':
              router.push({ name: 'login', params: { autoescola: localStorage.getItem('schema') } })
              break;
            case '3':
              router.push({ name: 'loginInstrutor', params: { autoescola: localStorage.getItem('schema') } })
              break;
            case '4':
              router.push({ name: 'loginAluno', params: { autoescola: localStorage.getItem('schema') } })
              break;
            case '5':
              router.push({ name: 'login', params: { autoescola: localStorage.getItem('schema') } })
              break;
            case '6':
              router.push({ name: 'login', params: { autoescola: localStorage.getItem('schema') } })
              break;
            case '7':
              router.push({ name: 'login', params: { autoescola: localStorage.getItem('schema') } })
              break;
            case '8':
              router.push({ name: 'login', params: { autoescola: localStorage.getItem('schema') } })
              break;
            case '9':
              router.push({ name: 'login', params: { autoescola: localStorage.getItem('schema') } })
              break;

            default:
              break;
          }
          this.$refs.logoff.close()
        }else
        {
          switch (localStorage.getItem('id_role')) {
            case '1':
              router.push({ name: 'dashboard' })
              break;
            case '2':
              router.push({ name: 'DashboardMonitoramento' })
              break;
            case '3':
              router.push({ name: 'dash-instrutor' })
              break;
            case '4':
              router.push({ name: 'aulas-teoricas' })
              break;
            case '5':
              router.push({ name: 'dashboard' })
              break;
            case '6':
              router.push({ name: 'Financeiro' })
              break;
            case '7':
              router.push({ name: 'EnvioAulasPraticas' })
              break;
            case '9':
              router.push({ name: 'Getran-listarAlunos' })
              break;
            default:
              break;
          }
        }
      }
    },
    computed: {
      ...mapState({
        login: state => state.app.login
      })
    },
    watch: {
      login(status){
        if(!status && !this.rotasLogin.includes(this.$route.name) && !this.openRoutes.includes(this.$route.name))
        {
          // a rota está pegando somente apos o acesso
          this.$refs.logoff.open()
        }
        // if(this.rotasLogin.includes(this.$route.name) && status)
        // {
        //   // this.redirect()
        // }
      },
      $route(rota,rota_old) {
        if(!this.rotasLogin.includes(rota.name) && rota.name != null && rota_old.name != null && this.rotasEad.includes(this.$route.name))
        {
          console.log(window.location.pathname)
          console.log(rota_old.name+' => '+rota.name)
          if(!this.login)
          {
            this.$refs.logoff.open()
          }
        }else if(this.rotasLogin.includes(rota.name) && this.login)
        {
          this.redirect()
        }
      }
    }
}
</script>

<style lang="scss">
  @import "sass/main";

  body {
    height: 100%;
    #app {
      height: 100%;
    }

    font-family: "Nunito Sans", sans-serif;

    scrollbar-width: thin;
    scrollbar-color: #1C2D5A;

    .row {
      margin-left: 0;
      margin-right: 0;
    }
  }

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: #F1F1F1;       
  }

  ::-webkit-scrollbar-thumb {
    background-color: #1C2D5A;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #4e629a;
  }

  #downloadButton{
    position: relative;
  }

  #downloadButton .tooltiptext {
    visibility: hidden;
    width: 140px;
    background-color: #555;
    color: #fff;
    text-align: center;
    padding: 5px 0;
    border-radius: 6px;

    /* Position the tooltip text */
    position: absolute;
    z-index: 1;
    top: 145%;
    left: 50%;
    margin-left: -70px; /* Use half of the width (120/2 = 60), to center the tooltip */

    /* Fade in tooltip */
    opacity: 0;
    transition: opacity 0.3s;
  }

  #downloadButton .tooltiptext::after {
    content: " ";
    position: absolute;
    bottom: 100%;  /* At the top of the tooltip */
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent black transparent;
  }

  #downloadButton:hover{
    color: orange;
    cursor: pointer;
  }

  #downloadButton:hover .tooltiptext{
    visibility: visible;
    opacity: 1;
  }
</style>
